// src/auth/AuthContext.tsx
import { createContext, useContext } from 'react';
import { AuthContextType } from './types';

// Valeur par défaut (jamais utilisée si le Provider est bien configuré)
const defaultAuthContext: AuthContextType = {
	isAuthenticated: false,
	isLoading: true,
	user: null,
	error: null,
	login: async () => {
		throw new Error('AuthProvider not configured');
	},
	logout: async () => {
		throw new Error('AuthProvider not configured');
	},
	getToken: async () => {
		throw new Error('AuthProvider not configured');
	},
	getIdTokenClaims: async () => {
		throw new Error('AuthProvider not configured');
	}
};

export const AuthContext = createContext<AuthContextType>(defaultAuthContext);

// Hook d'utilisation - C'EST LUI QUI SERA UTILISÉ PARTOUT
export const useAuth = (): AuthContextType => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error('useAuth must be used within an AuthProvider');
	}
	return context;
};

